<template>
  <div class="box-detail">
    <div class="box-left">
      <div class="box-left-header-contact">
        <!-- <div @click="$router.push({ path: '/Addresses' })" class="goBack">
          <i class="el-icon-arrow-left"></i>
          <span>地址</span>
          <i class="el-icon-office-building"></i>
        </div> -->
        <div class="profile-info">
          <el-image
            style="width: 72px; height: 72px;border-radius:50%;"
            src="https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg"
            fit="cover"
          ></el-image>
          <span>{{ formData.name }}</span>
          <ul class="shortcuts">
            <li>
              <el-tooltip
                class="item"
                effect="dark"
                content="打个电话"
                placement="top"
                :open-delay="300"
              >
                <a :href="'tel:' + formData.phone">
                  <el-button icon="el-icon-phone f-bold" circle></el-button>
                </a>
              </el-tooltip>
              <span>呼叫</span>
            </li>
            <li>
              <el-tooltip
                class="item"
                effect="dark"
                content="发送邮件"
                placement="top"
                :open-delay="300"
              >
                <a :href="'mailto:' + formData.email">
                  <el-button icon="el-icon-message f-bold" circle></el-button>
                </a>
              </el-tooltip>
              <span>邮件</span>
            </li>
            <li>
              <el-tooltip
                class="item"
                effect="dark"
                content="创建笔记"
                placement="top"
                :open-delay="300"
              >
                <el-button
                  icon="el-icon-edit-outline f-bold"
                  circle
                  @click="
                    activeTab = 'notes';
                    openNote = true;
                  "
                ></el-button>
              </el-tooltip>
              <span>笔记</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="box-left-content">
        <el-form
          ref="formData"
          :model="formData"
          :rules="rules"
          label-width="110px"
          label-position="left"
          hide-required-asterisk
        >
          <el-form-item label="地址" prop="address">
            <el-input
              v-model="formData.address"
              suffix-icon="el-icon-office-building"
              @blur="getGeocode"
              @change="$forceUpdate()"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="省市区"
            prop="area"
            :rules="{
              required: true,
              type: 'array',
              trigger: 'blur',
              message: '省市区不能为空'
            }"
          >
            <el-cascader
              :options="area.options"
              :props="area.props"
              v-model="formData.area"
              clearable
            ></el-cascader>
          </el-form-item>

          <el-form-item label="经度" prop="longitude">
            <el-input
              v-model="formData.longitude"
              disabled
              placeholder="根据地址自动生成"
            ></el-input>
          </el-form-item>
          <el-form-item label="纬度" prop="dimension">
            <el-input
              v-model="formData.dimension"
              disabled
              placeholder="根据地址自动生成"
            ></el-input>
          </el-form-item>
          <el-form-item label="地址类型" prop="addressType">
            <el-select v-model="formData.addressType">
              <el-option
                v-for="item in options.addressType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="地址说明" prop="addressDescription">
            <el-input v-model="formData.addressDescription"></el-input>
          </el-form-item>
          <el-form-item label="地理编码准确度" prop="accuracy">
            <el-input v-model="formData.accuracy"></el-input>
          </el-form-item>
          <el-form-item label="位置类型" prop="locationType">
            <el-select v-model="formData.locationType">
              <el-option
                v-for="item in options.locationType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="邮编" prop="zipCode">
            <el-input v-model="formData.zipCode"></el-input>
          </el-form-item>
          <el-form-item label="街道地址" prop="streetName">
            <el-input v-model="formData.streetName"></el-input>
          </el-form-item>
          <el-form-item label="时区" prop="timeZone">
            <el-input v-model="formData.timeZone"></el-input>
          </el-form-item>
          <el-form-item v-for="(extField, idx) in extFields" :key="idx" :label="extField.nameDisp">
            <template
              v-if="
                extField.type == 'text' || extField.type == 'textarea' || extField.type == 'number'
              "
            >
              <el-input v-model="formData.exts[extField.name]" :type="extField.type"></el-input>
            </template>
            <template v-if="extField.type == 'radio'">
              <el-radio-group v-model="formData.exts[extField.name]">
                <el-radio
                  v-for="item in options[extField.valueOption]"
                  :key="item.value"
                  :label="item.value"
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </template>
            <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
              <el-checkbox-group v-model="formData.exts[extField.name]">
                <el-checkbox
                  v-for="item in options[extField.valueOption]"
                  :label="item.value"
                  :key="item.value"
                >
                  {{ item.label }}
                </el-checkbox>
              </el-checkbox-group>
            </template>
            <template v-if="extField.type == 'select'">
              <el-select v-model="formData.exts[extField.name]" placeholder="请选择" clearable>
                <el-option
                  v-for="item in options[extField.valueOption]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
            <template v-if="extField.type == 'cascade'">
              <el-cascader
                clearable
                v-model="formData.exts[extField.name]"
                :options="options[extField.valueOption]"
                :props="{ checkStrictly: true, label: 'name' }"
              ></el-cascader>
            </template>
            <template v-if="extField.type == 'time'">
              <el-time-select
                v-model="formData.exts[extField.name]"
                placeholder="选择时间"
              ></el-time-select>
            </template>
            <template v-if="extField.type == 'date' || extField.type == 'datetime'">
              <el-date-picker
                v-model="formData.exts[extField.name]"
                :type="extField.type"
                placeholder="选择日期"
              ></el-date-picker>
            </template>
            <template v-if="extField.type == 'switch'">
              <el-switch
                v-model="formData.exts[extField.name]"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-value="1"
                inactive-value="0"
              ></el-switch>
            </template>
            <template v-if="extField.type == 'rate'">
              <el-rate v-model="formData.exts[extField.name]" @change="$forceUpdate()"></el-rate>
            </template>
          </el-form-item>
        </el-form>
      </div>
      <div class="box-left-footer">
        <el-button type="primary" @click="doSave">提交</el-button>
        <el-button plain @click="getData">取消</el-button>
      </div>
    </div>
    <!-- 动态 笔记 -->
    <div class="box-center">
      <el-tabs v-model="activeTab" class="c-h-1 c-flex c-flex-col">
        <el-tab-pane label="动态" name="log">
          <div class="box-center-tool">
            <div>
              <el-date-picker
                v-model="log.searchDate"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                clearable
                @change="getLog"
                class="search-date"
              ></el-date-picker>
            </div>
            <div>
              <el-input
                placeholder="请输入标题/内容"
                v-model="log.searchValue"
                class="search-input"
                clearable
                @clear="getLog"
                @keyup.enter.native="getLog"
              >
                <el-button slot="append" icon="el-icon-search" @click="getLog"></el-button>
              </el-input>
            </div>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(log, i) in log.fpi.data" :key="i">
              <div class="activity-card-header">
                <span class="c-font-500">
                  <i class="el-icon-monitor c-w-30"></i>
                  {{ log.title }}
                </span>
                <span>{{ log.createTime }}</span>
              </div>
              <div class="activity-card-content">{{ log.content }}</div>
              <div class="activity-card-footer">
                <span>操作人：{{ log.updateUserName }}</span>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="笔记" name="notes">
          <div class="box-center-tool">
            <div></div>
            <el-button
              type="primary"
              size="mini"
              @click="
                vqeditor.content = ``;
                openNote = true;
              "
            >
              创建笔记
            </el-button>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(note, i) in noteData" :key="i">
              <div class="activity-card-header">
                <span>
                  <i class="el-icon-edit-outline c-w-30"></i>
                  笔记
                </span>
                <span>{{ note.createTime }}</span>
              </div>
              <div
                class="activity-card-content-node"
                v-html="note.content"
                @click="noteMdShow(note)"
                v-if="!note.openNote"
              ></div>
              <!-- <quill-editor
                v-else
                class="editor c-m-15"
                v-model="note.content"
                ref="myQuillEditor"
                :options="vqeditor.editorOption"
              ></quill-editor> -->
              <c-editor
                v-else
                class="c-m-15"
                :formData="note"
                :value="'content'"
                ref="editor"
              ></c-editor>
              <div class="activity-card-footer">
                <span>操作人：{{ note.createUserName }}</span>
              </div>
            </div>
          </div>
          <!-- markdown编辑器 -->
          <el-dialog title="笔记" :visible.sync="openNote">
            <!-- <quill-editor
              class="editor"
              v-model="vqeditor.content"
              ref="myQuillEditor"
              :options="vqeditor.editorOption"
            ></quill-editor> -->
            <c-editor :formData="vqeditor" :value="'content'" ref="editor"></c-editor>
            <div slot="footer">
              <el-button type="primary" @click="saveNote">确 认</el-button>
              <el-button
                @click="
                  openNote = false;
                  vqeditor.content = '';
                "
              >
                取 消
              </el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="属性变更记录" name="history">
          <div
            class="box-center-content"
            v-infinite-scroll="getHistory"
            :infinite-scroll-immediate="true"
          >
            <c-modify
              :historyFpi="historyFpi"
              :fields="extFields"
              :fieldsObj="fieldsObj"
              :options="options"
              ref="modify"
            ></c-modify>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="box-right" :class="collapse ? 'box-collapse' : ''">
      <div class="box-right-header">
        <i class="el-icon-d-arrow-left" @click="collapse = false" v-if="collapse"></i>
        <i class="el-icon-d-arrow-right" @click="collapse = true" v-else></i>
      </div>
      <div class="box-right-content" v-show="!collapse">
        <el-collapse>
          <el-collapse-item v-if="isShow || serviceAppointment.relatedData.length">
            <template slot="title">
              <span>工单</span>
              <el-button
                type="text"
                icon="el-icon-plus"
                @click.stop="newServiceAppointment"
                v-if="serviceAppointment.relatedData.length == 0"
              >
                添加工单
              </el-button>
              <el-tooltip
                v-else
                class="item"
                effect="dark"
                content="1个地址只允许关联1个工单"
                placement="top-end"
              >
                <i class="el-icon-info c-color-primary"></i>
              </el-tooltip>
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of serviceAppointment.relatedData" :key="i">
                <div>
                  <i class="el-icon-tickets card-item-logo"></i>
                </div>
                <div>
                  <p>
                    <el-link
                      @click="osg.open('', '', '_blank', '/ServiceAppointment/' + item._id)"
                      target="_blank"
                    >
                      {{ item.title }}
                    </el-link>
                  </p>
                  <p>阶段：{{ osg.codelabel('stage', item.stage) }}</p>
                </div>
                <i
                  class="el-icon-close card-item-icon-remove"
                  @click="removeServiceAppointment(item)"
                ></i>
                <i
                  class="el-icon-edit card-item-icon-edit"
                  @click="editServiceAppointment(item)"
                ></i>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item v-if="isShow || contact.relatedData.length">
            <template slot="title">
              <span>客户</span>
              <el-button
                type="text"
                icon="el-icon-plus"
                @click.stop="newContact"
                v-if="contact.relatedData.length == 0"
              >
                添加客户
              </el-button>
              <el-tooltip
                v-else
                class="item"
                effect="dark"
                content="1个地址只允许关联1个客户"
                placement="top-end"
              >
                <i class="el-icon-info c-color-primary"></i>
              </el-tooltip>
            </template>

            <div class="card-group">
              <div class="card-item" v-for="(item, i) of contact.relatedData" :key="i">
                <div>
                  <i class="el-icon-office-building card-item-logo"></i>
                </div>
                <div>
                  <p>
                    <el-link :href="'/contact/' + item._id" target="_blank">
                      {{ item.name }}
                    </el-link>
                  </p>
                  <p class="card-item-link">
                    <el-link :href="item.website" target="_blank">
                      {{ item.domainName }}
                    </el-link>
                  </p>
                </div>
                <i class="el-icon-close card-item-icon-remove" @click="removeContact(item)"></i>
                <i class="el-icon-edit card-item-icon-edit" @click="editContact(item)"></i>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item v-if="isShow || company.relatedData.length">
            <template slot="title">
              <span>公司</span>
              <el-button
                type="text"
                icon="el-icon-plus"
                @click.stop="newCompany"
                v-if="company.relatedData.length == 0"
              >
                添加公司
              </el-button>
              <el-tooltip
                v-else
                class="item"
                effect="dark"
                content="1个地址只允许关联1个公司"
                placement="top-end"
              >
                <i class="el-icon-info c-color-primary"></i>
              </el-tooltip>
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of company.relatedData" :key="i">
                <div>
                  <i class="el-icon-office-building card-item-logo"></i>
                </div>
                <div>
                  <p>
                    <el-link
                      @click="osg.open('', '', '_blank', '/Company/' + item._id)"
                      target="_blank"
                    >
                      {{ item.name }}
                    </el-link>
                  </p>
                  <p class="card-item-link">
                    <el-link :href="item.website" target="_blank">{{ item.domainName }}</el-link>
                  </p>
                </div>
                <i class="el-icon-close card-item-icon-remove" @click="removeCompany(item)"></i>
                <i class="el-icon-edit card-item-icon-edit" @click="editCompany(item)"></i>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>

      <el-drawer
        custom-class="c-drawer"
        title="添加工单"
        :visible.sync="serviceAppointment.openRelate"
        direction="rtl"
      >
        <div class="el-drawer__content">
          <el-tabs v-model="serviceAppointment.activeName" type="card">
            <el-tab-pane label="选择已有工单" name="search">
              <p class="c-m-b-10 c-font-13">请输入工单标题/客户名称进行搜索</p>
              <el-select
                v-model="serviceAppointment.searchObj"
                filterable
                remote
                reserve-keyword
                placeholder
                :remote-method="getServiceAppointmentData"
                clearable
                @clear="getServiceAppointmentData"
                :loading="false"
                @change="$forceUpdate()"
                class="c-w-1"
              >
                <el-option
                  v-for="item in serviceAppointment.data"
                  :key="item._id"
                  :label="item.title"
                  :value="item"
                >
                  <span class="c-fl">标题：{{ item.title }}</span>
                  <span class="c-fr c-font-13">{{ item.name }}</span>
                </el-option>
              </el-select>
            </el-tab-pane>
            <el-tab-pane label="新建工单" name="create">
              <el-form
                :model="serviceAppointment.formData"
                :rules="rules"
                ref="serviceAppointmentFormData"
                label-width="90px"
                label-position="left"
                hide-required-asterisk
              >
                <el-form-item label="客户姓名" prop="name">
                  <el-input
                    v-model="serviceAppointment.formData.name"
                    suffix-icon="el-icon-mobile-phone"
                  ></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                  <el-input
                    v-model="serviceAppointment.formData.phone"
                    suffix-icon="el-icon-mobile-phone"
                  ></el-input>
                </el-form-item>
                <el-form-item label="省市区" prop="area" v-if="serviceAppointment.openRelate">
                  <el-cascader
                    :props="area.props"
                    v-model="serviceAppointment.formData.area"
                  ></el-cascader>
                </el-form-item>
                <el-form-item label="详细地址" prop="address">
                  <el-input v-model="serviceAppointment.formData.address"></el-input>
                </el-form-item>
                <el-form-item label="工单标题" prop="title">
                  <el-input v-model="serviceAppointment.formData.title"></el-input>
                </el-form-item>
                <el-form-item label="优先级">
                  <el-radio-group
                    v-model="serviceAppointment.formData.priority"
                    @change="$forceUpdate()"
                  >
                    <el-radio
                      v-for="item of options.priority"
                      :key="item.value"
                      :label="item.value"
                    >
                      {{ item.label }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="预约时间" prop="applyTime">
                  <el-date-picker
                    v-model="serviceAppointment.formData.applyTime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetime"
                    placeholder="选择日期时间"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="描述" prop="describe">
                  <el-input type="textarea" :rows="2" v-model="formData.describe"></el-input>
                </el-form-item>
                <el-form-item label="阶段">
                  <el-select v-model="serviceAppointment.formData.stage">
                    <el-option
                      v-for="item in options.stage"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="状态">
                  <el-select v-model="serviceAppointment.formData.status">
                    <el-option
                      v-for="item in options.status"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      v-show="serviceAppointment.formData.stage == item.value.slice(0, -2)"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="el-drawer__footer" v-if="serviceAppointment.activeName == 'search'">
          <el-button
            type="primary"
            :disabled="!serviceAppointment.searchObj._id"
            @click="
              saveServiceAppointment('search');
              initServiceAppointment();
            "
          >
            保存
          </el-button>
          <el-button plain @click="initServiceAppointment()">取消</el-button>
        </div>
        <div class="el-drawer__footer" v-if="serviceAppointment.activeName == 'create'">
          <el-button type="primary" @click="saveServiceAppointment('create')">保存</el-button>
          <el-button plain @click="initServiceAppointment">取消</el-button>
        </div>
      </el-drawer>
      <el-drawer
        custom-class="c-drawer"
        title="编辑工单"
        :visible.sync="serviceAppointment.openEdit"
        direction="rtl"
        :before-close="initServiceAppointment"
      >
        <div class="el-drawer__content">
          <el-form
            :model="serviceAppointment.formData"
            :rules="rules"
            ref="serviceAppointmentFormData"
            label-width="90px"
            label-position="left"
            hide-required-asterisk
          >
            <el-form-item label="客户姓名" prop="name">
              <el-input
                v-model="serviceAppointment.formData.name"
                suffix-icon="el-icon-mobile-phone"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
              <el-input
                v-model="serviceAppointment.formData.phone"
                suffix-icon="el-icon-mobile-phone"
              ></el-input>
            </el-form-item>
            <el-form-item label="省市区" prop="area" v-if="serviceAppointment.openEdit">
              <el-cascader
                :props="area.props"
                v-model="serviceAppointment.formData.area"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="详细地址" prop="address">
              <el-input v-model="serviceAppointment.formData.address"></el-input>
            </el-form-item>
            <el-form-item label="工单标题" prop="title">
              <el-input v-model="serviceAppointment.formData.title"></el-input>
            </el-form-item>
            <el-form-item label="优先级">
              <el-radio-group
                v-model="serviceAppointment.formData.priority"
                @change="$forceUpdate()"
              >
                <el-radio v-for="item of options.priority" :key="item.value" :label="item.value">
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="预约时间" prop="applyTime">
              <el-date-picker
                v-model="serviceAppointment.formData.applyTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择日期时间"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="描述" prop="describe">
              <el-input type="textarea" :rows="2" v-model="formData.describe"></el-input>
            </el-form-item>
            <el-form-item label="阶段">
              <el-select v-model="serviceAppointment.formData.stage">
                <el-option
                  v-for="item in options.stage"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="serviceAppointment.formData.status">
                <el-option
                  v-for="item in options.status"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  v-show="serviceAppointment.formData.stage == item.value.slice(0, -2)"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="el-drawer__footer">
          <el-button type="primary" @click="saveServiceAppointment()">保存</el-button>
          <el-button plain @click="initServiceAppointment()">取消</el-button>
        </div>
      </el-drawer>

      <el-drawer
        custom-class="c-drawer"
        title="添加客户"
        :visible.sync="contact.openRelate"
        direction="rtl"
      >
        <div class="el-drawer__content">
          <el-tabs v-model="contact.activeName" type="card">
            <el-tab-pane label="选择已有客户" name="search">
              <p class="c-m-b-10 c-font-13">请输入客户名称进行搜索</p>
              <el-select
                v-model="contact.search_contact"
                filterable
                remote
                reserve-keyword
                placeholder
                suffix-icon="el-icon-date"
                :remote-method="getContactData"
                clearable
                @clear="getContactData"
                :loading="false"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="item in contact.data"
                  :key="item._id"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </el-tab-pane>
            <el-tab-pane label="创建客户" name="create">
              <el-form
                :model="contact.formData"
                :rules="rules"
                ref="contactFormData"
                label-width="70px"
                label-position="left"
                hide-required-asterisk
              >
                <el-form-item label="姓名" prop="name">
                  <el-input v-model="contact.formData.name" suffix-icon="el-icon-user"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                  <el-input
                    v-model="contact.formData.phone"
                    suffix-icon="el-icon-mobile-phone"
                  ></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                  <el-input
                    v-model="contact.formData.email"
                    suffix-icon="el-icon-message"
                  ></el-input>
                </el-form-item>
                <el-form-item label="地址" prop="address">
                  <el-input v-model="contact.formData.address"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="leadStatus">
                  <el-select v-model="contact.formData.leadStatus">
                    <el-option
                      v-for="item in options.leadStatus"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="阶段" prop="lifecycleStage">
                  <el-select v-model="contact.formData.lifecycleStage">
                    <el-option
                      v-for="item in options.lifecycleStage"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  v-for="(extField, idx) in extFields"
                  :key="idx"
                  :label="extField.nameDisp"
                >
                  <template
                    v-if="
                      extField.type == 'text' ||
                        extField.type == 'textarea' ||
                        extField.type == 'number'
                    "
                  >
                    <el-input
                      v-model="contact.formData.exts[extField.name]"
                      :type="extField.type"
                    ></el-input>
                  </template>
                  <template v-if="extField.type == 'radio'">
                    <el-radio-group v-model="formData.exts[extField.name]">
                      <el-radio
                        v-for="item in options[extField.valueOption]"
                        :key="item.value"
                        :label="item.value"
                      >
                        {{ item.label }}
                      </el-radio>
                    </el-radio-group>
                  </template>
                  <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
                    <el-checkbox-group v-model="formData.exts[extField.name]">
                      <el-checkbox
                        v-for="item in options[extField.valueOption]"
                        :label="item.value"
                        :key="item.value"
                      >
                        {{ item.label }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </template>
                  <template v-if="extField.type == 'select'">
                    <el-select
                      v-model="contact.formData.exts[extField.name]"
                      placeholder="请选择"
                      clearable
                    >
                      <el-option
                        v-for="item in options[extField.valueOption]"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </template>
                  <template v-if="extField.type == 'time'">
                    <el-time-select
                      v-model="contact.formData.exts[extField.name]"
                      placeholder="选择时间"
                    ></el-time-select>
                  </template>
                  <template v-if="extField.type == 'date' || extField.type == 'datetime'">
                    <el-date-picker
                      v-model="contact.formData.exts[extField.name]"
                      :type="extField.type"
                      placeholder="选择日期"
                    ></el-date-picker>
                  </template>
                  <template v-if="extField.type == 'switch'">
                    <el-switch
                      v-model="contact.formData.exts[extField.name]"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      active-value="1"
                      inactive-value="0"
                    ></el-switch>
                  </template>
                  <template v-if="extField.type == 'rate'">
                    <el-rate
                      v-model="contact.formData.exts[extField.name]"
                      @change="$forceUpdate()"
                    ></el-rate>
                  </template>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="el-drawer__footer" v-if="contact.activeName == 'search'">
          <el-button
            type="primary"
            @click="
              doSaveContact();
              initContact();
            "
          >
            保存
          </el-button>
          <el-button
            plain
            @click="
              getData();
              initContact();
            "
          >
            取消
          </el-button>
        </div>
        <div class="el-drawer__footer" v-if="contact.activeName == 'create'">
          <el-button
            type="primary"
            @click="
              saveContact();
              initContact();
            "
          >
            保存
          </el-button>
          <el-button plain @click="initContact">取消</el-button>
        </div>
      </el-drawer>
      <el-drawer
        custom-class="c-drawer"
        title="编辑客户"
        :visible.sync="contact.openEdit"
        direction="rtl"
        :before-close="initContact"
      >
        <div class="el-drawer__content">
          <el-form
            :model="contact.formData"
            :rules="rules"
            ref="contactFormData"
            label-width="70px"
            label-position="left"
            hide-required-asterisk
          >
            <el-form-item label="姓名" prop="name">
              <el-input v-model="contact.formData.name" suffix-icon="el-icon-user"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
              <el-input
                v-model="contact.formData.phone"
                suffix-icon="el-icon-mobile-phone"
              ></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="contact.formData.email" suffix-icon="el-icon-message"></el-input>
            </el-form-item>
            <el-form-item label="地址" prop="address">
              <el-input v-model="contact.formData.address"></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="leadStatus">
              <el-select v-model="contact.formData.leadStatus">
                <el-option
                  v-for="item in options.leadStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="阶段" prop="lifecycleStage">
              <el-select v-model="contact.formData.lifecycleStage">
                <el-option
                  v-for="item in options.lifecycleStage"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-for="(extField, idx) in extFields"
              :key="idx"
              :label="extField.nameDisp"
            >
              <template
                v-if="
                  extField.type == 'text' ||
                    extField.type == 'textarea' ||
                    extField.type == 'number'
                "
              >
                <el-input
                  v-model="contact.formData.exts[extField.name]"
                  :type="extField.type"
                ></el-input>
              </template>
              <template v-if="extField.type == 'radio'">
                <el-radio-group v-model="formData.exts[extField.name]">
                  <el-radio
                    v-for="item in options[extField.valueOption]"
                    :key="item.value"
                    :label="item.value"
                  >
                    {{ item.label }}
                  </el-radio>
                </el-radio-group>
              </template>
              <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
                <el-checkbox-group v-model="formData.exts[extField.name]">
                  <el-checkbox
                    v-for="item in options[extField.valueOption]"
                    :label="item.value"
                    :key="item.value"
                  >
                    {{ item.label }}
                  </el-checkbox>
                </el-checkbox-group>
              </template>
              <template v-if="extField.type == 'select'">
                <el-select
                  v-model="contact.formData.exts[extField.name]"
                  placeholder="请选择"
                  clearable
                >
                  <el-option
                    v-for="item in options[extField.valueOption]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </template>
              <template v-if="extField.type == 'time'">
                <el-time-select
                  v-model="contact.formData.exts[extField.name]"
                  placeholder="选择时间"
                ></el-time-select>
              </template>
              <template v-if="extField.type == 'date' || extField.type == 'datetime'">
                <el-date-picker
                  v-model="contact.formData.exts[extField.name]"
                  :type="extField.type"
                  placeholder="选择日期"
                ></el-date-picker>
              </template>
              <template v-if="extField.type == 'switch'">
                <el-switch
                  v-model="contact.formData.exts[extField.name]"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </template>
              <template v-if="extField.type == 'rate'">
                <el-rate
                  v-model="contact.formData.exts[extField.name]"
                  @change="$forceUpdate()"
                ></el-rate>
              </template>
            </el-form-item>
          </el-form>
        </div>
        <div class="el-drawer__footer">
          <el-button
            type="primary"
            @click="
              saveContact();
              initContact();
            "
          >
            保存
          </el-button>
          <el-button plain @click="initContact()">取消</el-button>
        </div>
      </el-drawer>

      <el-drawer
        custom-class="c-drawer"
        title="添加公司"
        :visible.sync="company.openRelate"
        direction="rtl"
      >
        <div class="el-drawer__content">
          <el-tabs v-model="company.activeName" type="card">
            <el-tab-pane label="选择已有公司" name="search">
              <p class="c-m-b-10 c-font-13">请输入公司名称/负责人名称进行搜索</p>
              <el-select
                v-model="formData.companyId"
                filterable
                remote
                reserve-keyword
                placeholder
                suffix-icon="el-icon-date"
                :remote-method="getCompanyData"
                clearable
                @clear="getCompanyData"
                :loading="false"
                @change="$forceUpdate()"
                class="c-w-1"
              >
                <el-option
                  v-for="item in company.data"
                  :key="item._id"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </el-tab-pane>
            <el-tab-pane label="新建公司" name="create">
              <el-form
                :model="company.formData"
                :rules="rules"
                ref="companyFormData"
                label-width="70px"
                label-position="left"
                hide-required-asterisk
              >
                <el-form-item label="名称" prop="name">
                  <el-input v-model="company.formData.name"></el-input>
                </el-form-item>
                <el-form-item label="行业" prop="industry">
                  <el-select v-model="company.formData.industry">
                    <el-option
                      v-for="item in options.industry"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="联系电话">
                  <el-input v-model="company.formData.phone"></el-input>
                </el-form-item>
                <el-form-item label="客户ID">
                  <el-input v-model="company.formData.ownerId"></el-input>
                </el-form-item>
                <el-form-item label="类型">
                  <el-select v-model="company.formData.type">
                    <el-option
                      v-for="item in options.companytype"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="描述">
                  <el-input v-model="company.formData.description"></el-input>
                </el-form-item>
                <el-form-item label="网址" prop="website">
                  <el-input v-model="company.formData.website"></el-input>
                </el-form-item>
                <el-form-item label="域名" prop="domainName">
                  <el-autocomplete
                    v-model="company.formData.domainName"
                    suffix-icon="el-icon-paperclip"
                    :fetch-suggestions="querySearch"
                  ></el-autocomplete>
                </el-form-item>
                <el-form-item label="成立时间" prop="foundTime">
                  <el-date-picker
                    v-model="company.formData.foundTime"
                    type="date"
                    placeholder="选择日期"
                  ></el-date-picker>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="el-drawer__footer" v-if="company.activeName == 'search'">
          <el-button
            type="primary"
            @click="
              editSaveCompany();
              initCompany();
            "
          >
            保存
          </el-button>
          <el-button
            plain
            @click="
              getData();
              initCompany();
            "
          >
            取消
          </el-button>
        </div>
        <div class="el-drawer__footer" v-if="company.activeName == 'create'">
          <el-button
            type="primary"
            @click="
              saveCompany();
              initCompany();
            "
          >
            保存
          </el-button>
          <el-button plain @click="initCompany">取消</el-button>
        </div>
      </el-drawer>
      <el-drawer
        custom-class="c-drawer"
        title="编辑公司"
        :visible.sync="company.openEdit"
        direction="rtl"
        :before-close="initCompany"
      >
        <div class="el-drawer__content">
          <el-form
            :model="company.formData"
            :rules="rules"
            ref="companyFormData"
            label-width="70px"
            label-position="left"
            hide-required-asterisk
          >
            <el-form-item label="名称" prop="name">
              <el-input v-model="company.formData.name"></el-input>
            </el-form-item>
            <el-form-item label="行业" prop="industry">
              <el-select v-model="company.formData.industry">
                <el-option
                  v-for="item in options.industry"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="联系电话">
              <el-input v-model="company.formData.phone"></el-input>
            </el-form-item>
            <el-form-item label="客户ID">
              <el-input v-model="company.formData.ownerId"></el-input>
            </el-form-item>
            <el-form-item label="类型">
              <el-select v-model="company.formData.type">
                <el-option
                  v-for="item in options.companytype"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="描述">
              <el-input v-model="company.formData.description"></el-input>
            </el-form-item>
            <el-form-item label="网址" prop="website">
              <el-input v-model="company.formData.website"></el-input>
            </el-form-item>
            <el-form-item label="域名" prop="domainName">
              <el-autocomplete
                v-model="company.formData.domainName"
                suffix-icon="el-icon-paperclip"
                :fetch-suggestions="querySearch"
              ></el-autocomplete>
            </el-form-item>
            <el-form-item label="成立时间" prop="foundTime">
              <el-date-picker
                v-model="company.formData.foundTime"
                type="date"
                placeholder="选择日期"
              ></el-date-picker>
            </el-form-item>
          </el-form>
        </div>
        <div class="el-drawer__footer">
          <el-button
            type="primary"
            @click="
              saveCompany();
              initCompany();
            "
          >
            保存
          </el-button>
          <el-button plain @click="initCompany()">取消</el-button>
        </div>
      </el-drawer>
    </div>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';
export default {
  activated() {
    window.$this = this;
  },
  name: 'contact',
  data() {
    let that = this;
    return {
      id: null,
      collapse: false,
      formData: { exts: {} },
      fieldsObj: {},
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      options: {
        //客户
        codecfg_leadStatus: { codeId: 'LEADSTATUS' },
        codecfg_lifecycleStage: { codeId: 'LIFECYCLESTAGE' },
        //工单
        codecfg_priority: { codeId: 'PRIORITY' },
        codecfg_stage: { codeId: 'STAGE' },
        codecfg_status: { codeId: 'STATUS' },
        //公司
        codecfg_companytype: { codeId: 'COMPANYTYPE' },
        codecfg_industry: { codeId: 'INDUSTRY' },
        //地址
        codecfg_addressType: { codeId: 'ADDRESSTYPE' },
        codecfg_locationType: { codeId: 'LOCATIONTYPE' }
      },
      rules: this.$util.rules,
      activeTab: 'log',
      // 日志
      log: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      historyFpi: {
        page: 1,
        rows: 0,
        data: [],
        busy: false
      },
      noteData: [],
      openNote: false,
      vqeditor: this.$util.vqeditor,
      contact: {
        relatedData: [], //关联的数组
        openRelate: false, //是否打开表单
        openEdit: false, //是否打开编辑表单
        Date: [], //搜索已有的公司 返回的数组 可以叫options
        formData: {}, //搜索/新增/编辑 表单数据
        activeName: 'search', //当前激活的tab,
        search_contact: '' //搜索客户
      },
      serviceAppointment: {
        relatedData: [],
        openRelate: false,
        openEdit: false,
        Date: [],
        formData: {},
        activeName: 'search',
        searchObj: {} //搜索选中要关联的工单对象
      },
      company: {
        relatedData: [],
        openRelate: false,
        openEdit: false,
        Date: [],
        formData: {},
        activeName: 'search'
      },
      //地址级联-懒加载
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true
        }
      }
    };
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
    isShow() {
      return (
        !this.serviceAppointment.relatedData.length &&
        !this.contact.relatedData.length &&
        !this.company.relatedData.length
      );
    }
  },
  beforeDestroy() {
    this.editor = null;
    delete this.editor;
  },
  mounted() {
    window.$this = this;
    this.id = this.osg.param('id');
    this.osg.getFields('address', () => {
      this.getData();
    });
    this.getLog();
    this.getNote();
  },
  methods: {
    //获取地理编码
    async getGeocode() {
      if (this.formData.area[0] && this.formData.area[1]) {
        var citys = await this.$util.getCity(this.formData.area[0]);
        var cityName = '';
        for (var city of citys) {
          if (city._id == this.formData.area[1]) {
            var cityName = city.name;
            break;
          }
        }
        this.osg.geocode(cityName + this.formData.address, res => {
          this.formData.longitude = res.location.split(',')[0];
          this.formData.dimension = res.location.split(',')[1];
          this.$forceUpdate();
        });
      }
    },
    //上传头像图片文件转base64
    getFileToBase64(file, fileList) {
      var that = this;
      const isJPG = file.raw.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.osg.toast('上传头像图片只能是 JPG 格式！', 'error');
        return;
      }
      if (!isLt2M) {
        this.osg.toast('上传头像图片大小不能超过 2MB！', 'error');
        return;
      }
      this.$util.Base64.imgFile(file.raw).then(res => {
        if (res) {
          that.formData.avatar = res;
          that.$forceUpdate();
        } else {
          this.osg.toast('上传失败', 'error');
        }
      });
    },
    getData() {
      this.osg.ajax('basic/address/queryById.do', { id: this.id }, res => {
        this.$util.renderExtField(this.extFields, res);
        /*渲染省市区*/
        var row = res;
        var area = [];
        if (row.province) {
          area[0] = row.province;
        }
        if (row.city) {
          area[1] = row.city;
        }
        if (row.district) {
          area[2] = row.district;
        }
        row.area = area;
        this.area.show = true;
        this.formData = res;
        //获取属性修改记录
        this.getHistory();
        //获取关联的客户
        this.getContactData(null, this.formData.typeId);
        //获取关联的公司
        this.getCompanyData(null, this.formData.typeId);
        //获取关联的工单
        this.getServiceAppointmentData(null, this.formData.typeId);
      });
    },
    getContactData(query, typeId) {
      var params = {
        page: 1,
        rows: 10,
        'regex:name|string#or': query,
        'eq:_id|string#and': typeId, //只查关于自己地址的客户
        'is:state|integer#and': 1,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax(
        'basic/contacts/query.do',
        params,
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          if (typeId) {
            this.contact.relatedData = res.data;
          } else {
            this.contact.data = res.data;
            this.contact.relatedData = [];
          }
          this.$forceUpdate();
        },
        { noload: true }
      );
    },
    getServiceAppointmentData(query, typeId) {
      var params = {
        page: 1,
        rows: 10,
        'regex:name|string#or': query,
        'regex:title|string#or': query,
        'eq:_id|string#and': typeId,
        'is:state|integer#and': 1,
        sortField: 'createTime',
        sortOrder: 'desc',
        _all: '1'
      };
      //搜索关联（全部工单），不返回已关联的工单
      // if (!typeId) {
      //   params["ne:companyId|null#"] = null;
      // }
      this.osg.ajax(
        'basic/serviceAppointment/query.do',
        params,
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          if (typeId) {
            this.serviceAppointment.relatedData = res.data;
          } else {
            this.serviceAppointment.data = res.data;
            this.serviceAppointment.relatedData = [];
          }
          this.$forceUpdate();
        },
        { noload: true }
      );
    },
    getCompanyData(query, typeId) {
      var params = {
        page: 1,
        rows: 10,
        'regex:title|string#or': query,
        'regex:name|string#or': query,
        'eq:_id|string#and': typeId,
        'is:state|integer#and': 1,
        sortField: 'createTime',
        sortOrder: 'desc',
        _all: '1'
      };
      this.osg.ajax(
        'basic/company/query.do',
        params,
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          if (typeId) {
            this.company.relatedData = res.data;
          } else {
            this.company.data = res.data;
            this.serviceAppointment.relatedData = [];
          }
          this.$forceUpdate();
        },
        { noload: true }
      );
    },
    doSave() {
      if (this.osg.validate()) {
        var params = this.formData;
        params.area = params.area || [];
        if (params.area.length > 0) {
          params.province = params.area[0] || '';
          if (params.area.length > 1) {
            params.city = params.area[1] || '';
            if (params.area.length > 2) {
              params.district = params.area[2] || '';
            }
          }
        }
        // delete params.area;
        this.$util.saveExtField(this.extFields, params);
        this.osg.ajax('basic/address/upsert.do', params, res => {
          this.osg.toast('保存成功！');
          this.getData();
        });
      }
    },
    getLog() {
      this.log.searchDate = this.log.searchDate || [];
      this.osg.ajax(
        'tenantLog/query.do',
        {
          sid: this.id,
          smodule: 'address',
          _all: '1',
          'regex:title|string#or': this.log.searchValue,
          'regex:content|string#or': this.log.searchValue,
          'gte:createTime|datetime#and': this.log.searchDate[0],
          'lte:createTime|datetime#and': this.log.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.log.fpi = res;
        },
        { noload: true }
      );
    },
    getHistory() {
      // 其他getFields查询会更新掉表单的fieldsObj
      let fieldsObj = {};
      this.extFields.map(item => {
        if (item.showList && item.showList.indexOf('6') != -1) {
          item.label = item.nameDisp;
          item.value = item.name;
          fieldsObj[item.name] = item;
        }
      });
      this.fieldsObj = fieldsObj;
      this.osg.ajax(
        'biz/changeLog/query.do',
        {
          sid: this.id,
          page: this.historyFpi.page,
          rows: (this.historyFpi.rows += 10)
        },
        res => {
          if (res.data.length > 0) {
            // 不需要展示变更的字段名
            res.data = res.data.filter(item => {
              item.modifyList = item.modifyList.filter(obj => {
                return (
                  this.fieldsObj[obj.field] && this.fieldsObj[obj.field].showList.indexOf('6') != -1
                );
              });
              return item.modifyList.length > 0;
            });
            this.historyFpi = res;
          }
        },
        { noload: true }
      );
    },
    getFields() {
      this.osg.ajax(
        'biz/ext/queryByColName/address.do',
        {},
        res => {
          res.entity.extFieldList.map(item => {
            item.label = item.nameDisp;
            item.value = item.name;
          });
          this.options.fields = res.entity.extFieldList;
        },
        {
          noload: true
        }
      );
    },
    formatField(row, column, cellValue) {
      return this.osg.codelabel('fields', cellValue);
    },
    formatFieldValue(row, column, cellValue) {
      if (this.options[row.field]) {
        return this.osg.codelabel(row.field, cellValue);
      } else {
        return cellValue;
      }
    },
    getNote() {
      this.osg.ajax(
        'note/query.do',
        {
          sid: this.id,
          smodule: 'address'
        },
        res => {
          this.noteData = res || [];
        }
      );
    },
    //保存笔记
    saveNote() {
      var params = {
        //sid，smodul，content，id，isDelete(值Y) 保存传123,修改传1234,删除传12345
        sid: this.id,
        smodule: 'address',
        content: this.vqeditor.content
      };
      this.osg.ajax('note/upsert.do', params, res => {
        this.osg.toast('保存成功！');
        this.openNote = false;
        this.getNote();
      });
    },
    noteMdShow(note) {
      note.openNote = true;
    },
    // 新增客户
    newContact() {
      this.contact.openRelate = true;
      this.getContactData();
    },
    //选择客户保存
    doSaveContact() {
      let contactData = this.contact.data.filter(item => item._id == this.contact.search_contact);
      let contactDataId = contactData[0]._id;
      this.formData.typeId = contactDataId;
      this.formData.type = 0;

      this.doSave();
    },
    //删除客户
    removeContact(item) {
      this.osg.confirm(`删除与 "${item.title}" 的关联？`, () => {
        this.formData.typeId = '';
        this.doSave();
      });
    },
    //编辑客户
    editContact(item) {
      this.contact.formData = item;
      this.contact.openEdit = true;
    },
    saveContact() {
      if (this.osg.validate('contactFormData')) {
        this.osg.ajax('basic/contacts/upsert.do', this.contact.formData, res => {
          this.formData.typeId = res.data._id;
          this.doSave();
        });
      }
    },
    initContact() {
      this.contact.openEdit = false;
      this.contact.openRelate = false;
      this.contact.formData = {};
      this.contact.search_contact = '';
    },
    // 关联工单
    newServiceAppointment() {
      this.serviceAppointment.openRelate = true;
      this.getServiceAppointmentData();
    },
    saveServiceAppointment(type) {
      this.formData.type = 2;

      //搜索关联
      if (type == 'search') {
        this.formData.typeId = this.serviceAppointment.searchObj._id;
        this.doSave();
        this.initServiceAppointment();
      } else {
        this.$nextTick(() => {
          let obj = JSON.parse(JSON.stringify(this.serviceAppointment.formData));
          obj.area = obj.area || [];
          if (obj.area.length > 0) {
            obj.province = obj.area[0];
            if (obj.area.length > 1) {
              obj.city = obj.area[1];
              if (obj.area.length > 2) {
                obj.district = obj.area[2];
              }
            }
          }
          delete obj.area;
          if (this.osg.validate('serviceAppointmentFormData')) {
            this.osg.ajax(
              'basic/serviceAppointment/upsert.do',
              { data: JSON.stringify(obj) },
              res => {
                this.formData.typeId = res.entity._id;
                this.doSave();
                this.getData();
                this.initServiceAppointment();
              }
            );
          }
        });
      }
    },
    removeServiceAppointment(item) {
      this.osg.confirm(`删除与 "${item.title}" 的关联？`, () => {
        this.formData.typeId = '';
        this.doSave();
      });
    },
    editServiceAppointment(item) {
      var area = [];
      if (item.province) {
        area[0] = item.province;
      }
      if (item.city) {
        area[1] = item.city;
      }
      if (item.district) {
        area[2] = item.district;
      }
      item.area = area;
      this.serviceAppointment.formData = item;
      this.serviceAppointment.openEdit = true;
    },
    initServiceAppointment() {
      this.serviceAppointment.searchObj = {};
      this.serviceAppointment.openEdit = false;
      this.serviceAppointment.openRelate = false;
      this.serviceAppointment.formData = {};
    },
    // 关联公司
    newCompany() {
      this.company.openRelate = true;
      this.getCompanyData();
    },
    editCompany(item) {
      this.company.formData = item;
      this.company.openEdit = true;
    },
    editSaveCompany() {
      let contactData = this.company.data.filter(item => item._id == this.formData.companyId);
      let contactDataId = contactData[0]._id;
      this.formData.typeId = contactDataId;
      this.formData.type = 1;
      this.doSave();
    },
    saveCompany() {
      if (this.osg.validate('companyFormData')) {
        this.osg.ajax('basic/company/upsert.do', this.company.formData, res => {
          if (this.formData.typeId != res.data._id) {
            this.formData.typeId = res.data._id;
            this.formData.type = 1;
            this.doSave();
          }
        });
      }
    },
    removeCompany(item) {
      this.osg.confirm(`删除与 "${item.name}" 的关联？`, () => {
        this.formData.typeId = '';
        this.company.relatedData = [];
        this.doSave();
        this.$forceUpdate();
      });
    },
    initCompany() {
      this.company.openEdit = false;
      this.company.openRelate = false;
      this.company.formData = {};
    },
    //根据网址 提示域名下拉框
    querySearch(queryString, cb) {
      let url = this.company.formData.website;
      let reg = /^((https|http|ftp|rtsp|mms){0,1}(:\/\/){0,1})www\.(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/;
      if (reg.test(url)) {
        if (url.indexOf('www.') != -1) {
          url = url.substr(url.indexOf('.') + 1);
        } else if (url.indexOf('http://') != -1) {
          url = url.substr(url.indexOf('/', url.indexOf('/') + 1) + 1);
        } else if (url.indexOf('https://') != -1) {
          url = url.substr(url.indexOf('/', url.indexOf('/') + 1) + 1);
          if (url.indexOf('https://www.') != -1) {
            url = url.substr(url.indexOf('.') + 1);
          }
        }
        // 调用 callback 返回建议列表的数据
        cb([{ label: url, value: url }]);
        this.$forceUpdate();
      } else {
        cb([{}]);
        this.$forceUpdate();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
/*个人信息*/
.box-left-header-contact {
  border-bottom: 1px solid #dfe3eb;
}
.profile-info {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.profile-info > * {
  margin: 10px auto;
}
.profile-info > span {
  margin: 0;
  font-weight: 400;
  font-size: 24px;
}
.profile-info ul {
  display: flex;
}
.profile-info ul li {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 5px;
}
.profile-info ul li span {
  margin-top: 8px;
  font-size: 12px;
}
/* 快捷按钮 */
.shortcuts button {
  background-color: #eaf0f6;
  border-color: #cbd6e2;
  color: #506e91;
}
.shortcuts button i {
  font-weight: bold;
}
</style>
